export default {
  toggleClass(parent: HTMLElement, selector: string, className: string, force: boolean): void {
    const element = parent.querySelector(selector);
    element?.classList.toggle(className, force);
  },

  toggleClassOnMultiple(
    parent: HTMLElement,
    selector: string,
    className: string,
    force: boolean,
  ): void {
    const elements = parent.querySelectorAll(selector);
    elements.forEach((el) => el.classList.toggle(className, force));
  },

  placeCursorAtEnd(el: HTMLElement) {
    el.focus();

    const range = document.createRange();
    range.selectNodeContents(el);
    range.collapse(false); // end

    const sel = window.getSelection();
    sel?.removeAllRanges();
    sel?.addRange(range);
  },
};
